.programmeInformationContainer {
    display: flex;
    align-self: center;
    gap: var(--bi-scale-4x);
    background-color: var(--bi-primary-5);
    color: var(--bi-primary-90);
    border-radius: var(--bi-radius-medium);

    max-width: calc(1128px - var(--bi-scale-16x));
    font-size: 1rem;

    @media (768px <= width < 1024px) {
        font-size: 0.875rem;
    }
}

.programmeInformationList {
    display: flex;
    padding: var(--bi-scale-4x);

    @media (width < 768px) {
        width: 100dvi;
        flex-direction: column;
        gap: var(--bi-scale-2x);
        padding: var(--bi-scale-8x) var(--bi-scale-4x);
    }
}

.programmeInformationListItem {
    display: flex;
    align-items: center;
    gap: var(--bi-scale-2x);

    /* Icon is beeing eaten by a lot of content, forcing it to shrink. To avoid that we set a min-width. */
    svg {
        min-width: 32px;
        @media (width < 768px) {
            min-width: 24px;
        }
    }
}

.listItemLink {
    min-width: 156px;
    max-width: 179px;

    @media (width < 768px) {
        font-weight: 600;
    }
}

.programmeInformationTextContainer {
    padding: 0 var(--bi-scale-1x);
}

.programmeInformationLabel {
    font-weight: 700;
}

.programmeFeeLink {
    color: var(--bi-primary-90);
}

.divider {
    border-right: 1px solid var(--bi-primary-90);
    opacity: 0.15;
    height: var(--bi-scale-6x);
    margin: auto var(--bi-scale-6x);

    @media (width < 1024px) {
        margin: auto var(--bi-scale-3x);
    }
}
